import React, { useCallback } from 'react';
import { FieldArrayRenderProps, useFieldArray } from 'react-final-form-arrays';

import { WalletSteeringFormValues } from '@occc-app/routes/Audience/types';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';
import { walletSteeringItemInitialValues } from './constants';
import { WalletSteeringFormArrayItem } from './components/WalletSteeringFormArrayItem';

import { AddAnotherItem } from '../AddAnotherItem';
import { FormArrayItemSection } from '../FormArrayItemSection';

type WalletSteeringFormContentProps = {
  name: string;
};

export const WalletSteeringFormContent: React.FC<WalletSteeringFormContentProps> = React.memo(
  ({ name }) => {
    const { fields } = useFieldArray<WalletSteeringFormValues>(name, {
      subscription: {
        length: true,
      },
    });
    const handleAddItem = useCallback(() => fields.push(walletSteeringItemInitialValues), [fields]);
    const handleRemoveItem = useCallback((index: number) => fields.remove(index), [fields]);

    const { isEditable } = useCanEditFormFieldsContext();
    const isDeleteIconShown = isEditable && Boolean(fields.length && fields.length > 1);

    const renderContent: Parameters<
      FieldArrayRenderProps<WalletSteeringFormValues, any>['fields']['map']
    >[0] = useCallback(
      (fieldArrayName, index) => {
        return (
          <React.Fragment key={fieldArrayName}>
            <FormArrayItemSection
              index={index}
              title={`Wallet ${index + 1}`}
              isDeleteIconShown={isDeleteIconShown}
              onDeleteClick={handleRemoveItem}
            />
            <WalletSteeringFormArrayItem fieldArrayName={fieldArrayName} />
          </React.Fragment>
        );
      },
      [handleRemoveItem, isDeleteIconShown],
    );

    return (
      <>
        {fields.map(renderContent)}
        <AddAnotherItem title='Add Another Wallet' onClick={handleAddItem} />
      </>
    );
  },
);
